import Product from './product';
import ProductUtils from './product-utils';

export default class ProductPoints {
    constructor(data, skusInCart) {
        this.data = data;
        this._options = [];
        this._skusInCart = skusInCart;
    }

    get imageUrl() {
        return this.data.hasOwnProperty('imageUrl') ? this.data.imageUrl : '';
    }

    get name() {
        return this.data.hasOwnProperty('name') ? this.data.name : '';
    }

    get groupId() {
        return this.data.hasOwnProperty('groupId') ? this.data.groupId : '';
    }

    get url(){
        return this.data.hasOwnProperty('url') ? this.data.url : null;
    }

    get skus(){
        return this.data.hasOwnProperty('skus') ? this.data.skus : null;
    }

    get skusInCart(){
        return this._skusInCart;
    }

    set skusInCart(val){
        this._skusInCart = val;
    }

    get isInCart(){
        return this._skusInCart && Object.keys(this._skusInCart).length;
    }

    get productType(){
        return this.data.hasOwnProperty('productType') ? this.data.productType : null;
    }

    get points(){
        return this.data.hasOwnProperty('points') ? this.data.points : null;
    }

    get mub(){
        return this.data.hasOwnProperty('mub') ? this.data.mub : null;
    }

    // get mubJson(){
    //     return JSON.stringify(this.mub);
    // }

    get hasOptions(){
        //return this._options.length > 1 ? true : false;
        const len = this._options.length;
        if(len > 1){
            return true;
        }
        // no options or only one options but no description
        return !len || (len === 1 && !this._options[0].option) ? false : true;
    }

    get options(){
        return this._options.length ? this._options : null;
    }

    set options(options){
        const skus = this.skus;
        const len = options && options.length;
        this._options = [];
        for(let i = 0; i < len; i++){
            if(skus && skus.hasOwnProperty(options[i].sku)){
                this._options.push(options[i]);
            }
        }
    }

    get optionsSelect(){
        let options = [];

        const len = this.options.length;
        for(let i = 0; i < len; i++){
            options.push({
                value: this.options[i].sku,
                label: ProductUtils.getOptionsText({options: this.options[i].option}, ' &nbsp;&nbsp; '),
            });
        }
        //console.log('get options select', options);
        return options;
    }

    get selectPlaceholder(){
        let placeHolder = [];
        if(this.options.length){
            const list = this.options[0].option;
            const len = list.length;
            for(let i = 0; i < len; i++){
                placeHolder.push(list[i].option);
            }
        }
        return placeHolder.join(' / ');
    }

    getOptionsForCard(pointsAvailable, skusToAdd, allowZeroQty){
        let options = [];
        const list = this.options;

        if(!list){
            return options;
        }
        //console.log('this._skusInCart ', this._skusInCart);
        //console.log('skusToAdd ', this.skusToAdd);
        const len = list.length;
        for(let i = 0; i < len; i++){
            const sku = list[i].sku;
            // items that will be added (user updated quantities but didn't submitted data)
            const tempAdded = skusToAdd && skusToAdd.hasOwnProperty(sku) ? skusToAdd[sku] : null;
            // already added to cart
            const quantity = this._skusInCart && this._skusInCart.hasOwnProperty(sku) ? this._skusInCart[sku] : 0;
            // check max quantity considering stock and available points
            const maxQuantity = Math.min(list[i].stock, Math.floor(pointsAvailable / this.getPointsForSku(sku))) + (tempAdded !== null ? tempAdded : quantity);
            // console.log('min ', tempAdded, Math.floor(pointsAvailable / this.getPointsForSku(sku)));
            // console.log('option tempAdded, quantity ', list[i].stock, quantity);
            // console.log('option maxQuantity ', list[i], maxQuantity);
            const data = {
                sku: sku,
                name: ProductUtils.getOptionsText({options: list[i].option}, ' / ', ' '),
                quantity: (tempAdded !== null ? tempAdded : (!allowZeroQty && quantity < maxQuantity ? quantity + 1 : quantity)),
                maxQuantity: maxQuantity,
                points: this.points,
                type: this.productType,
                stock: list[i].stock,
                imageUrl: list[i].imageUrl
            };
            //console.log('option data ', data);

            options.push(new Product(data));
        }
        return options;
    }

    getPointsForSku(sku){
        const skus = this.skus;
        if(skus){
            //console.log('getPointsForSku skus ', skus);
            for(let key in skus){
                if(key === sku){
                    //console.log('getPointsForSku found ', skus[key]);
                    return skus[key];
                }
            }
        }
        return this.points;
    }
}